import { LoginAction } from "../../actions/Login/loginAction";
import { LoginActionType } from "../../actionTypes/Login";


type loginState = {
    access_token: string,
    refresh_token: string,
    access_token_lifespan: number,
    refresh_token_lifespan: number,
    isSuperUser: boolean,
    branches: any[],
    loading: boolean,
    success: boolean,
    error: string,

};

const initialState: loginState = {
    access_token: "",
    refresh_token: "",
    access_token_lifespan: 0,
    refresh_token_lifespan: 0,
    isSuperUser: false,
    branches: [],
    loading: false,
    success: false,
    error: ""
};

const loginReducer = (state = initialState, action: LoginAction): any => {
    switch (action.type) {
        case LoginActionType.POST_LOGIN_SUCCESS:
            return {
                ...state,
                loading: false,
                error: action.error,
                success: action.success,
                access_token: action.payload.access_token,
                refresh_token: action.payload.refresh_token,
                isSuperUser: action.payload.isSuperUser,
                branches: action.payload.branches
            };
        case LoginActionType.POST_LOGIN_UNSUCCESS:
            return {
                ...state,
                loading: false,
                error: action.error,
                success: action.success,
            };
        default:
            return state
    }
}

export default loginReducer